// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevCardGridController {
	/* @ngInject */
	/**
	 */
	constructor() {
		this.options = {
			parent: {
				create: false,
				kid: 'K_NODE;0000015MDZ8PB7HCD4FY',
				isa: {
					objid: 'K_NODE;OPERATION',
					objname: 'Opération',
					kright: 15
				},
				name: 'titit',
				target: null,
			}
		}
		this.values = [];
	}
}
